export default __webpack_public_path__ + "_/images/app/apk/apk-2-a2b7c5a44025aae1b35773f8ee6fbd490a5eecd23f1e040585734ba68d6dd6ad.png";